/* Ardor Printing AI A-frame sign generator (sections/ardor-aframe-idea.liquid, template page.ai-a-frame-sign-generator). 2026-10-08.
   Adapted from the AI banner generator (assets/ardor-banner-idea.js): same look, Turnstile and email-unlock flow, and the
   same visitor id + email (localStorage wsIdeaVisitor / wsIdeaEmail), so one email unlocks every AI generator.
   Worker routes: /api/banner/quota, /logo, /generate (product "aframe"), /fix, /final. Tries share the banner counters.
   Two sign sizes only, portrait: 24 x 36 in (widthFt 2, heightFt 3) and 22 x 28 in (widthFt 22/12, heightFt 28/12).
   "Use this design" -> /api/banner/final -> <builder>?ai=<finalId>&size=24x36|22x28[&logo=<logoId>&lb=x0,y0,x1,y1].
   Before redirecting it fires a cancelable "ardor:aframe-ai-handoff" event on the section (detail.url);
   calling preventDefault() on it stops the redirect (used by the local test harness).
   No jQuery and no libraries except Cloudflare Turnstile. ASCII only (other characters as \u escapes). */
(function () {
  'use strict';
  const root = document.querySelector('[data-ardor-aframe-ai]');
  if (!root || root.dataset.afiReady) return;
  root.dataset.afiReady = '1';

  const $ = (s, c = root) => c.querySelector(s);
  const $$ = (s, c = root) => Array.from(c.querySelectorAll(s));
  const API = (root.dataset.api || '').replace(/\/+$/, '');
  const SITEKEY = root.dataset.turnstile || '';
  const BUILDER = root.dataset.builder || '/products/signicade-a-frame-sign-sandwich-board';
  const MAX_LOGO_PX = 1536;
  const MAX_LOGO_BYTES = 8 * 1024 * 1024;
  const MAX_SOURCE_BYTES = 30 * 1024 * 1024;
  const LIMITS = { headline: 60, subline: 80, details: 120, notes: 300, fix: 200 };
  const STYLES = { bold: 'Bold', clean: 'Clean', fun: 'Fun', elegant: 'Elegant', vintage: 'Vintage', event: 'Event' };
  // The two A-frame sizes (inches) and the frames they fit. w/h in feet, as the worker expects.
  const SIZES = {
    '24x36': { key: '24x36', w: 2, h: 3, label: '24 x 36 in', frames: 'Deluxe and Standard Signicade' },
    '22x28': { key: '22x28', w: 22 / 12, h: 28 / 12, label: '22 x 28 in', frames: 'Simposign II' }
  };
  const DEFAULT_SIZE = '24x36';
  const LAST_KEY = 'ardorAFrameAiLast';
  const PICK_KEY = 'ardorAFrameAiPick';
  const DOT = ' \u00b7 ';
  const ELL = '\u2026';
  const OFF_MSG = 'The A-frame sign generator is taking a short break. Please try again later.';
  // [seconds, status text, step index (Layout, Your words, Spell check, Final touches), only when]
  const GEN_STEPS = [
    [0, 'Laying out your sign' + ELL, 0],
    [10, 'Setting your words' + ELL, 1],
    [22, 'Placing your logo' + ELL, 1, 'logo'],
    [34, 'Checking the spelling' + ELL, 2],
    [50, 'Double-checking every word' + ELL, 2],
    [66, 'Adding the final touches' + ELL, 3],
    [82, 'Almost there' + ELL, 3]
  ];

  /* ---------- storage (same keys as the sticker and banner generators for visitor + email) ---------- */
  const store = {
    get(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { window.localStorage.setItem(k, v); } catch (e) { /* private mode */ } }
  };
  const sget = (k) => { try { return JSON.parse(window.sessionStorage.getItem(k) || 'null'); } catch (e) { return null; } };
  const sset = (k, v) => { try { window.sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) { /* full or blocked */ } };

  let visitor = store.get('wsIdeaVisitor');
  if (!visitor || !/^[a-zA-Z0-9_-]{8,64}$/.test(visitor)) {
    visitor = (window.crypto && crypto.randomUUID ? crypto.randomUUID() : String(Date.now()) + Math.random().toString(36).slice(2)).replace(/[^a-zA-Z0-9_-]/g, '');
    store.set('wsIdeaVisitor', visitor);
  }
  let email = store.get('wsIdeaEmail') || '';

  function track(name, data) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data || {}); } catch (e) { /* ignore */ }
  }

  /* ---------- elements ---------- */
  const form = $('[data-afi-form]');
  const sizeBtns = $$('[data-size]');
  const sizeNote = $('[data-afi-size-note]');
  const drop = $('[data-afi-drop]');
  const fileIn = $('[data-afi-file]');
  const logoRow = $('[data-afi-logo]');
  const logoImg = $('[data-afi-logo-img]');
  const logoName = $('[data-afi-logo-name]');
  const logoInfo = $('[data-afi-logo-info]');
  const logoErr = $('[data-afi-logo-err]');
  const lineIns = { headline: $('[data-afi-line="headline"]'), subline: $('[data-afi-line="subline"]'), details: $('[data-afi-line="details"]') };
  const headErr = $('[data-afi-headline-err]');
  const notesIn = $('[data-afi-notes]');
  const styleBtns = $$('[data-style]');
  const goBtn = $('[data-afi-go]');
  const goLabel = $('[data-afi-go-label]');
  const quotaEl = $('[data-afi-quota]');
  const errEl = $('[data-afi-err]');
  const results = $('[data-afi-results]');
  const metaEl = $('[data-afi-meta]');
  const echo = $('[data-afi-echo]');
  const h2 = $('[data-afi-h2]');
  const statusEl = $('[data-afi-status]');
  const loading = $('[data-afi-loading]');
  const bar = $('[data-afi-bar]');
  const stepEls = $$('[data-afi-steps] li');
  const grid = $('[data-afi-grid]');
  const againRow = $('[data-afi-again-row]');
  const againBtn = $('[data-afi-again]');
  const editBtn = $('[data-afi-edit]');
  const fineEl = $('.afi__fine');
  const gate = $('[data-afi-gate]');
  const gateForm = $('[data-afi-gate-form]');
  const gateEmail = $('[data-afi-email]');
  const gateErr = $('[data-afi-gate-err]');
  const gateN = $('[data-afi-gate-n]');

  const S = {
    size: DEFAULT_SIZE, style: 'bold',
    logo: null, // { blob, w, h, name, id, thumb (object URL or data URL), thumbData }
    batch: null, // { batchId, aspect, size, w, h, style, notes, lines, logoId, images }
    busy: false, off: false,
    triesLeft: null, fixesLeft: null, finalsLeft: null,
    hasEmail: !!email, freeTries: 2, emailTries: 10,
    pending: null
  };

  if (!API) {
    goBtn.disabled = true;
    quotaEl.hidden = true;
    return;
  }

  /* ---------- small helpers ---------- */
  const clean = (s) => String(s || '').replace(/\s+/g, ' ').trim();
  const enc = encodeURIComponent;
  const sizeOf = (k) => SIZES[k] || SIZES[DEFAULT_SIZE];
  const arOf = (k) => sizeOf(k).w / sizeOf(k).h;

  function showErr(msg, el = errEl) { el.textContent = msg || ''; el.hidden = !msg; }
  function setInvalid(el, bad) { if (bad) el.setAttribute('aria-invalid', 'true'); else el.removeAttribute('aria-invalid'); }
  function withEmail(body) { if (S.hasEmail && email) body.email = email; return body; }
  // The worker words its messages for signs on A-frame requests; "off" can still come from the shared route switch.
  const msgOf = (j, fallback) => (j && j.error === 'off' ? OFF_MSG : (j && j.message) || fallback);

  function setQuota() {
    if (S.triesLeft == null) return;
    const n = S.triesLeft;
    if (S.hasEmail) quotaEl.textContent = n > 0 ? `${n} tr${n === 1 ? 'y' : 'ies'} left today` : 'No tries left today';
    else quotaEl.textContent = n > 0 ? `${n} free tr${n === 1 ? 'y' : 'ies'}${DOT}4 designs each${DOT}no sign-up` : `Add your email for ${S.emailTries} tries a day`;
    if (gateN) gateN.textContent = String(S.emailTries);
    $$('.afi__fix-left', grid).forEach((el) => { el.textContent = fixesText(); });
  }
  function fixesText() {
    if (S.fixesLeft == null) return '';
    return `${S.fixesLeft} fix${S.fixesLeft === 1 ? '' : 'es'} left today`;
  }

  /* ---------- API ---------- */
  async function api(path, body, timeoutMs = 180000) {
    const opts = {};
    if (body instanceof FormData) { opts.method = 'POST'; opts.body = body; }
    else if (body) { opts.method = 'POST'; opts.headers = { 'Content-Type': 'application/json' }; opts.body = JSON.stringify(body); }
    let timer = 0;
    if (window.AbortController) {
      const ctl = new AbortController();
      opts.signal = ctl.signal;
      timer = setTimeout(() => ctl.abort(), timeoutMs);
    }
    let r;
    try {
      r = await fetch(API + path, opts);
    } catch (e) {
      clearTimeout(timer);
      if (e && e.name === 'AbortError') return { ok: false, error: 'timeout', message: 'This is taking longer than usual. Please try again.' };
      return { ok: false, error: 'network', message: 'Check your connection and try again.' };
    }
    let j = {};
    try { j = await r.json(); } catch (e) { j = {}; }
    clearTimeout(timer);
    if (!j || typeof j !== 'object') j = {};
    if (r.status === 402 && !j.error) j.error = 'need_email';
    if (!r.ok) {
      if (!j.error) j = { ok: false, error: 'server', message: 'Something went wrong on our side. Please try again.' };
      j.ok = false;
    }
    return j;
  }

  /* ---------- Turnstile (same as the other generators: explicit render, invisible, fresh token per POST) ---------- */
  let tsReady = null;
  let tsWidget = null;
  let tsResolve = null;
  function loadTurnstile() {
    if (!SITEKEY) return Promise.resolve(false);
    if (tsReady) return tsReady;
    tsReady = new Promise((res) => {
      if (window.turnstile && window.turnstile.render) { res(true); return; }
      window.afiTurnstileLoaded = () => res(true);
      const s = document.createElement('script');
      s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=afiTurnstileLoaded';
      s.async = true;
      s.defer = true;
      s.onerror = () => res(false);
      document.head.appendChild(s);
    });
    return tsReady;
  }
  async function botToken() {
    if (!SITEKEY || !(await loadTurnstile()) || !window.turnstile) return '';
    return new Promise((res) => {
      tsResolve = res;
      const take = (t) => { const r = tsResolve; if (r) { tsResolve = null; r(t || ''); } };
      try {
        if (tsWidget === null) {
          tsWidget = window.turnstile.render($('[data-afi-turnstile]'), {
            sitekey: SITEKEY,
            execution: 'execute',
            appearance: 'interaction-only',
            callback: (t) => take(t),
            'error-callback': () => take('')
          });
        } else {
          window.turnstile.reset(tsWidget);
        }
        window.turnstile.execute(tsWidget);
      } catch (e) { take(''); }
      setTimeout(() => { if (tsResolve === res) take(''); }, 45000);
    });
  }

  /* ---------- radio groups (size + style): click, arrow keys, roving tabindex ---------- */
  function radioGroup(btns, attr, onPick) {
    btns.forEach((b) => {
      b.addEventListener('click', () => onPick(b.dataset[attr]));
      b.addEventListener('keydown', (e) => {
        if (!['ArrowRight', 'ArrowLeft', 'ArrowDown', 'ArrowUp'].includes(e.key)) return;
        e.preventDefault();
        const i = btns.indexOf(b);
        const n = btns[(i + (e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : -1) + btns.length) % btns.length];
        onPick(n.dataset[attr]);
        n.focus();
      });
    });
  }
  function markRadio(btns, attr, value) {
    btns.forEach((b) => {
      const on = b.dataset[attr] === value;
      b.setAttribute('aria-checked', String(on));
      b.tabIndex = on ? 0 : -1;
    });
  }

  /* ---------- size ---------- */
  function setSize(k) {
    S.size = SIZES[k] ? k : DEFAULT_SIZE;
    markRadio(sizeBtns, 'size', S.size);
    const z = sizeOf(S.size);
    sizeNote.textContent = `Your designs come back in this exact ${z.label} shape. The same design goes on both sides of the sign.`;
  }
  radioGroup(sizeBtns, 'size', setSize);

  /* ---------- logo: any image -> PNG (max 1536 px long side) in the browser ---------- */
  const LOGO_TYPES = /^image\/(png|jpeg|jpg|pjpeg|webp|svg\+xml|gif)$/i;
  const LOGO_EXT = /\.(png|jpe?g|webp|svg|gif)$/i;
  function loadImg(src) {
    return new Promise((res, rej) => {
      const im = new Image();
      im.decoding = 'async';
      im.onload = () => res(im);
      im.onerror = () => rej(new Error('image'));
      im.src = src;
    });
  }
  function canvasBlob(img, w, h, type = 'image/png') {
    const c = document.createElement('canvas');
    c.width = w;
    c.height = h;
    const ctx = c.getContext('2d');
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(img, 0, 0, w, h);
    return new Promise((res, rej) => c.toBlob((b) => (b ? res(b) : rej(new Error('toBlob'))), type));
  }
  function thumbData(img, w, h) {
    const s = Math.min(1, 160 / Math.max(w, h));
    const c = document.createElement('canvas');
    c.width = Math.max(1, Math.round(w * s));
    c.height = Math.max(1, Math.round(h * s));
    c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
    try { return c.toDataURL('image/png'); } catch (e) { return ''; }
  }
  async function svgSource(file) {
    const txt = await file.text();
    const doc = new DOMParser().parseFromString(txt, 'image/svg+xml');
    const svg = doc.documentElement;
    if (!svg || svg.nodeName.toLowerCase() !== 'svg' || doc.getElementsByTagName('parsererror').length) throw new Error('svg');
    const dim = (a) => { const v = svg.getAttribute(a) || ''; return /%/.test(v) ? NaN : parseFloat(v); };
    let vw = dim('width');
    let vh = dim('height');
    const vb = (svg.getAttribute('viewBox') || '').trim().split(/[\s,]+/).map(Number);
    const hasVb = vb.length === 4 && vb[2] > 0 && vb[3] > 0;
    if (hasVb && !(vw > 0 && vh > 0)) { vw = vb[2]; vh = vb[3]; }
    if (!(vw > 0 && vh > 0)) { vw = 1024; vh = 1024; }
    if (!hasVb) svg.setAttribute('viewBox', `0 0 ${vw} ${vh}`);
    const s = MAX_LOGO_PX / Math.max(vw, vh); // vector: always render at the full 1536 px long side
    const w = Math.max(1, Math.round(vw * s));
    const h = Math.max(1, Math.round(vh * s));
    svg.setAttribute('width', String(w));
    svg.setAttribute('height', String(h));
    const src = URL.createObjectURL(new Blob([new XMLSerializer().serializeToString(svg)], { type: 'image/svg+xml' }));
    return { src, w, h };
  }
  async function toPng(file) {
    const isSvg = /svg/i.test(file.type) || /\.svg$/i.test(file.name);
    let src;
    let w;
    let h;
    if (isSvg) ({ src, w, h } = await svgSource(file));
    else src = URL.createObjectURL(file);
    try {
      const img = await loadImg(src);
      if (!isSvg) {
        const nw = img.naturalWidth;
        const nh = img.naturalHeight;
        if (!nw || !nh) throw new Error('size');
        const s = Math.min(1, MAX_LOGO_PX / Math.max(nw, nh));
        w = Math.max(1, Math.round(nw * s));
        h = Math.max(1, Math.round(nh * s));
      }
      let blob = await canvasBlob(img, w, h);
      for (let i = 0; i < 4 && blob.size > MAX_LOGO_BYTES; i++) {
        w = Math.max(1, Math.round(w * 0.75));
        h = Math.max(1, Math.round(h * 0.75));
        blob = await canvasBlob(img, w, h);
      }
      if (blob.size > MAX_LOGO_BYTES) throw new Error('big');
      return { blob, w, h, thumbData: thumbData(img, w, h) };
    } finally {
      URL.revokeObjectURL(src);
    }
  }
  function setLogo(L) {
    if (S.logo && S.logo.thumb && S.logo.thumb.indexOf('blob:') === 0) URL.revokeObjectURL(S.logo.thumb);
    S.logo = L;
    if (L) {
      logoImg.src = L.thumb || L.thumbData || '';
      logoName.textContent = L.name || 'Your logo';
      logoInfo.textContent = 'Added to every design';
    }
    logoRow.hidden = !L;
    drop.hidden = !!L;
  }
  async function takeLogo(file) {
    showErr('', logoErr);
    if (!(LOGO_TYPES.test(file.type || '') || LOGO_EXT.test(file.name || ''))) { showErr('Please choose a PNG, JPG, SVG, WEBP or GIF file.', logoErr); return; }
    if (file.size > MAX_SOURCE_BYTES) { showErr('That file is too big. Please use one under 30 MB.', logoErr); return; }
    drop.classList.add('is-busy');
    try {
      const out = await toPng(file);
      setLogo({ blob: out.blob, w: out.w, h: out.h, name: file.name, id: null, thumb: URL.createObjectURL(out.blob), thumbData: out.thumbData });
      track('ardor_aframe_ai_logo', {});
    } catch (e) {
      showErr("We couldn't read that file. Try saving your logo as a PNG or JPG.", logoErr);
    }
    drop.classList.remove('is-busy');
  }
  fileIn.addEventListener('change', () => {
    const f = fileIn.files && fileIn.files[0];
    if (f) takeLogo(f);
    fileIn.value = '';
  });
  ['dragenter', 'dragover'].forEach((t) => drop.addEventListener(t, () => drop.classList.add('is-over')));
  ['dragleave', 'drop'].forEach((t) => drop.addEventListener(t, () => drop.classList.remove('is-over')));
  $('[data-afi-logo-remove]').addEventListener('click', () => {
    setLogo(null);
    showErr('', logoErr);
    fileIn.focus();
  });
  async function uploadLogo() {
    const L = S.logo;
    if (!L) return '';
    if (L.id) return L.id;
    if (!L.blob) throw { message: 'Please add your logo again.' };
    const fd = new FormData();
    fd.append('file', L.blob, 'logo.png');
    fd.append('visitor', visitor);
    const j = await api('/api/banner/logo', fd, 60000);
    if (!j.ok || !j.logoId) throw j;
    L.id = j.logoId;
    return j.logoId;
  }

  /* ---------- wording + style ---------- */
  function syncCount(key, el) {
    const c = $(`[data-afi-count="${key}"]`);
    if (!c) return;
    const n = el.value.length;
    c.textContent = `${n}/${LIMITS[key]}`;
    c.classList.toggle('is-near', n >= LIMITS[key] - 5);
  }
  Object.keys(lineIns).forEach((k) => {
    lineIns[k].addEventListener('input', () => {
      syncCount(k, lineIns[k]);
      if (k === 'headline' && clean(lineIns[k].value)) { setInvalid(lineIns[k], false); showErr('', headErr); }
      showErr('');
    });
  });
  notesIn.addEventListener('input', () => syncCount('notes', notesIn));

  function setStyle(st) {
    S.style = STYLES[st] ? st : 'bold';
    markRadio(styleBtns, 'style', S.style);
  }
  radioGroup(styleBtns, 'style', setStyle);

  function readForm(show) {
    const headline = clean(lineIns.headline.value).slice(0, LIMITS.headline);
    setInvalid(lineIns.headline, !headline);
    if (!headline) {
      if (show) {
        showErr('Type the main words for your sign.', headErr);
        lineIns.headline.focus({ preventScroll: true });
        lineIns.headline.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return null;
    }
    const lines = { headline };
    const sub = clean(lineIns.subline.value).slice(0, LIMITS.subline);
    const det = clean(lineIns.details.value).slice(0, LIMITS.details);
    if (sub) lines.subline = sub;
    if (det) lines.details = det;
    const z = sizeOf(S.size);
    return { size: z.key, w: z.w, h: z.h, style: S.style, notes: clean(notesIn.value).slice(0, LIMITS.notes), lines, hasLogo: !!S.logo };
  }

  /* ---------- busy states ---------- */
  function setBusyUi(on) {
    goBtn.disabled = on || S.off;
    goLabel.textContent = on ? 'Designing' + ELL : 'Design my sign';
    againBtn.disabled = on;
    editBtn.disabled = on;
    $$('button, input', grid).forEach((el) => { el.disabled = on; });
  }
  let genTimer = 0;
  function placeholder(ar) {
    const c = document.createElement('div');
    c.className = 'afi__card is-loading';
    c.setAttribute('aria-hidden', 'true');
    c.innerHTML = `<div class="afi__frame" style="--ar:${ar}"><span class="afi__skel"><i></i><i></i><i></i></span></div><div class="afi__card-actions"><span class="afi__skel-btn"></span><span class="afi__skel-btn"></span></div>`;
    return c;
  }
  function startGenLoading(v) {
    S.busy = true;
    setBusyUi(true);
    results.hidden = false;
    loading.hidden = false;
    againRow.hidden = true;
    fineEl.hidden = true;
    echo.textContent = v.lines.headline;
    metaEl.textContent = `${sizeOf(v.size).label}${DOT}${STYLES[v.style]}`;
    grid.setAttribute('aria-busy', 'true');
    grid.innerHTML = '';
    for (let i = 0; i < 4; i++) grid.appendChild(placeholder(arOf(v.size)));
    const steps = GEN_STEPS.filter((m) => !m[3] || (m[3] === 'logo' && v.hasLogo));
    const t0 = Date.now();
    let last = -1;
    const tick = () => {
      const t = (Date.now() - t0) / 1000;
      bar.style.width = `${Math.min(95, 100 * (1 - Math.exp(-t / 36)))}%`;
      let k = 0;
      steps.forEach((m, i) => { if (t >= m[0]) k = i; });
      if (k === last) return;
      last = k;
      statusEl.textContent = steps[k][1];
      stepEls.forEach((li, i) => {
        li.classList.toggle('is-done', i < steps[k][2]);
        li.classList.toggle('is-on', i === steps[k][2]);
      });
    };
    clearInterval(genTimer);
    tick();
    genTimer = setInterval(tick, 250);
  }
  function stopGenLoading() {
    clearInterval(genTimer);
    S.busy = false;
    setBusyUi(false);
    loading.hidden = true;
    bar.style.width = '0';
    againRow.hidden = false;
    fineEl.hidden = false;
    grid.removeAttribute('aria-busy');
  }
  function cardBusy(card, title, sub, slow) {
    const o = $('.afi__busy', card);
    const fill = $('.afi__busy-bar i', card);
    $('.afi__busy-t', card).textContent = title;
    $('.afi__busy-s', card).textContent = sub;
    o.hidden = false;
    card.classList.add('is-busy');
    const t0 = Date.now();
    const tm = setInterval(() => { fill.style.width = `${Math.min(95, 100 * (1 - Math.exp(-(Date.now() - t0) / 1000 / slow)))}%`; }, 250);
    return () => { clearInterval(tm); o.hidden = true; card.classList.remove('is-busy'); fill.style.width = '0'; };
  }
  function cardErr(card, msg) { const el = card && $('.afi__cerr', card); if (el) showErr(msg, el); }
  const findCard = (id) => grid.querySelector(`.afi__card[data-id="${window.CSS && CSS.escape ? CSS.escape(id) : id}"]`);

  /* ---------- results ---------- */
  let uid = 0;
  function cardFor(img, i, fixed) {
    const b = S.batch;
    const flagged = !!(img.check && img.check.ok === false);
    const n = i + 1;
    const k = `afi-fix-${++uid}`;
    const card = document.createElement('article');
    card.className = `afi__card${flagged ? ' is-flagged' : ''}`;
    card.setAttribute('role', 'listitem');
    card.setAttribute('aria-label', `Design ${n}`);
    card.dataset.id = img.id;
    card.innerHTML = `
      <div class="afi__frame" style="--ar:${arOf(b.size)}">
        <img class="afi__img" alt="" decoding="async">
        ${fixed ? '<span class="afi__badge">Fixed</span>' : ''}
      </div>
      ${flagged ? '<p class="afi__flag"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3.5 2.5 20h19L12 3.5zM12 10v4.5M12 17.5v.01"/></svg><span>This one may have a spelling or logo mistake. Use Fix a word or pick another.</span></p>' : ''}
      <p class="afi__cerr" role="alert" hidden></p>
      <div class="afi__card-actions">
        <button type="button" class="ws-btn afi__use" data-act="use">Use this design<span class="afi__vh"> (design ${n})</span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg></button>
        <button type="button" class="ws-btn ws-btn--ghost afi__fixbtn" data-act="fix" aria-expanded="false" aria-controls="${k}">Fix a word<span class="afi__vh"> (design ${n})</span></button>
      </div>
      <form class="afi__fix" id="${k}" hidden novalidate>
        <label class="afi__flabel" for="${k}-in">What should we fix?</label>
        <div class="afi__fix-row">
          <input id="${k}-in" class="afi__input" type="text" maxlength="${LIMITS.fix}" autocomplete="off">
          <button type="submit" class="ws-btn ws-btn--ghost">Fix it</button>
        </div>
        <small class="afi__fix-left"></small>
      </form>
      <div class="afi__busy" hidden><span class="afi__spin" aria-hidden="true"></span><b class="afi__busy-t"></b><small class="afi__busy-s"></small><span class="afi__busy-bar" aria-hidden="true"><i></i></span></div>`;
    const im = $('.afi__img', card);
    im.alt = `A-frame sign design ${n}: ${b.lines.headline}`;
    im.addEventListener('load', () => card.classList.add('is-in'));
    im.addEventListener('error', () => card.classList.add('is-broken'));
    im.src = img.url;
    const fixForm = $('.afi__fix', card);
    const fixIn = $('input', fixForm);
    const fixBtn = $('[data-act="fix"]', card);
    fixIn.placeholder = 'e.g. Change "Cofee" to "Coffee"';
    $('.afi__fix-left', card).textContent = fixesText();
    $('[data-act="use"]', card).addEventListener('click', () => useDesign(img.id));
    fixBtn.addEventListener('click', () => {
      const open = fixForm.hidden;
      fixForm.hidden = !open;
      fixBtn.setAttribute('aria-expanded', String(open));
      if (!open) return;
      const wrong = img.check && Array.isArray(img.check.wrong) ? img.check.wrong.find((x) => x && x.expected && x.seen) : null;
      if (wrong && !fixIn.value) fixIn.value = `Change "${wrong.seen}" to "${wrong.expected}"`;
      fixIn.focus();
    });
    fixForm.addEventListener('submit', (e) => { e.preventDefault(); fixDesign(img.id, fixIn.value); });
    if (S.busy) $$('button, input', card).forEach((el) => { el.disabled = true; });
    return card;
  }
  function renderResults() {
    const b = S.batch;
    if (!b || !b.images || !b.images.length) { results.hidden = true; return; }
    results.hidden = false;
    loading.hidden = true;
    againRow.hidden = false;
    fineEl.hidden = false;
    echo.textContent = b.lines.headline;
    metaEl.textContent = `${sizeOf(b.size).label}${DOT}${STYLES[b.style] || ''}`;
    grid.innerHTML = '';
    b.images.forEach((img, i) => grid.appendChild(cardFor(img, i, !!img.fixedFrom)));
    const bad = b.images.filter((x) => x.check && x.check.ok === false).length;
    if (bad && bad === b.images.length) statusEl.textContent = 'These may have a mistake. Use Fix a word or make another set.';
    else statusEl.textContent = b.images.length > 1 ? `${b.images.length} designs ready. Pick your favorite.` : 'Your design is ready.';
  }
  function remember() {
    const L = S.logo;
    sset(LAST_KEY, {
      at: Date.now(),
      batch: S.batch,
      form: { size: S.size, style: S.style, notes: notesIn.value, headline: lineIns.headline.value, subline: lineIns.subline.value, details: lineIns.details.value },
      logo: L && L.id ? { id: L.id, name: L.name, w: L.w, h: L.h, thumbData: L.thumbData } : null
    });
  }

  /* ---------- generate / fix / final ---------- */
  async function generate() {
    if (S.busy || S.off) return;
    const v = readForm(true);
    if (!v) return;
    if (!S.hasEmail && S.triesLeft === 0) { S.pending = { kind: 'generate', run: generate }; openGate(); return; }
    showErr('');
    const prev = S.batch;
    startGenLoading(v);
    results.scrollIntoView({ behavior: 'smooth', block: 'start' });
    let logoId = '';
    if (v.hasLogo) {
      try {
        logoId = await uploadLogo();
      } catch (j) {
        stopGenLoading();
        S.batch = prev;
        renderResults();
        showErr((j && j.message) || "We couldn't upload your logo. Try another file, or remove it and try again.");
        form.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
    }
    const token = await botToken();
    const body = withEmail({ visitor, token, product: 'aframe', widthFt: v.w, heightFt: v.h, style: v.style, styleNotes: v.notes, lines: v.lines });
    if (logoId) body.logoId = logoId;
    const j = await api('/api/banner/generate', body);
    stopGenLoading();
    if (j.bannersLeft != null) S.triesLeft = j.bannersLeft;
    if (j.fixesLeft != null) S.fixesLeft = j.fixesLeft;
    if (!j.ok || !Array.isArray(j.images) || !j.images.length) {
      S.batch = prev;
      renderResults();
      if (j.error === 'need_email') {
        S.triesLeft = 0;
        setQuota();
        S.pending = { kind: 'generate', run: generate };
        openGate();
        return;
      }
      showErr(msgOf(j, "We couldn't make your designs this time. Please try again."));
      setQuota();
      form.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    if ('hasEmail' in j) S.hasEmail = !!j.hasEmail;
    S.batch = {
      batchId: j.batchId || '', aspect: j.aspect, size: v.size,
      w: v.w, h: v.h, style: v.style, notes: v.notes, lines: v.lines,
      logoId: logoId || null, images: j.images.slice(0, 8)
    };
    setQuota();
    renderResults();
    remember();
    h2.focus({ preventScroll: true });
    track('ardor_aframe_ai_generated', { style: v.style, size: v.size, logo: !!logoId, shown: j.images.length });
  }

  async function fixDesign(id, text) {
    if (S.busy) return;
    const card = findCard(id);
    if (!card) return;
    const input = $('.afi__fix input', card);
    const fix = clean(text).slice(0, LIMITS.fix);
    if (fix.length < 2) { cardErr(card, 'Tell us what to fix, like: Change "Cofee" to "Coffee".'); input.focus(); return; }
    if (!S.hasEmail && S.fixesLeft === 0) { S.pending = { kind: 'fix', run: () => fixDesign(id, fix) }; openGate(); return; }
    cardErr(card, '');
    S.busy = true;
    setBusyUi(true);
    const done = cardBusy(card, 'Fixing it' + ELL, 'Redoing just that part', 14);
    statusEl.textContent = 'Fixing your design' + ELL;
    const token = await botToken();
    const j = await api('/api/banner/fix', withEmail({ visitor, token, imageId: id, fix, product: 'aframe' }));
    done();
    S.busy = false;
    setBusyUi(false);
    if (j.fixesLeft != null) S.fixesLeft = j.fixesLeft;
    if (!j.ok || !Array.isArray(j.images) || !j.images.length) {
      setQuota();
      statusEl.textContent = '';
      if (j.error === 'need_email') { S.fixesLeft = 0; S.pending = { kind: 'fix', run: () => fixDesign(id, fix) }; openGate(); return; }
      cardErr(card, msgOf(j, 'That fix did not work. Please try again.'));
      return;
    }
    const idx = S.batch.images.findIndex((x) => x.id === id);
    const next = Object.assign({}, j.images[0], { fixedFrom: id });
    S.batch.images[idx] = next;
    const fresh = cardFor(next, idx, true);
    card.replaceWith(fresh);
    setQuota();
    remember();
    statusEl.textContent = next.check && next.check.ok === false
      ? 'Here is your fixed design. It may still have a mistake, so check it closely.'
      : 'Here is your fixed design.';
    $('[data-act="use"]', fresh).focus({ preventScroll: true });
    track('ardor_aframe_ai_fixed', { style: S.batch.style, size: S.batch.size });
  }

  function validBox(lb) {
    return Array.isArray(lb) && lb.length === 4 && lb.every((n) => typeof n === 'number' && Number.isFinite(n)) ? lb.map((n) => Math.min(1, Math.max(0, n))) : null;
  }
  // <builder>?ai=<finalId>&size=24x36|22x28[&logo=<logoId>&lb=x0,y0,x1,y1]
  function handoffUrl(aiId, size, logoId, lb) {
    let u = `${BUILDER}${BUILDER.indexOf('?') === -1 ? '?' : '&'}ai=${enc(aiId)}&size=${SIZES[size] ? size : DEFAULT_SIZE}`;
    if (logoId) {
      u += `&logo=${enc(logoId)}`;
      if (lb) u += `&lb=${lb.map((n) => n.toFixed(4)).join(',')}`;
    }
    return u;
  }
  async function useDesign(id) {
    if (S.busy || !S.batch) return;
    const card = findCard(id);
    const b = S.batch;
    const img = b.images.find((x) => x.id === id);
    if (!card || !img) return;
    cardErr(card, '');
    S.busy = true;
    setBusyUi(true);
    const done = cardBusy(card, 'Making a sharp, print-ready version' + ELL, 'about 30\u201360 seconds', 25);
    statusEl.textContent = 'Making a sharp, print-ready version' + ELL + ' about 30\u201360 seconds.';
    const token = await botToken();
    const j = await api('/api/banner/final', withEmail({ visitor, token, imageId: id, product: 'aframe' }));
    if (j.finalsLeft != null) S.finalsLeft = j.finalsLeft;
    if (!j.ok || !j.image || !j.image.id) {
      done();
      S.busy = false;
      setBusyUi(false);
      statusEl.textContent = '';
      if (j.error === 'need_email') { S.pending = { kind: 'final', run: () => useDesign(id) }; openGate(); return; }
      cardErr(card, msgOf(j, "We couldn't make the print version. Please try again."));
      return;
    }
    const fin = j.image;
    const lb = validBox(fin.check && fin.check.logoBox) || validBox(img.check && img.check.logoBox);
    const url = handoffUrl(fin.id, b.size, b.logoId, lb);
    sset(PICK_KEY, { ai: fin.id, url: fin.url, size: b.size, w: b.w, h: b.h, logo: b.logoId || null, lb, preview: id, lines: b.lines, style: b.style, at: Date.now() });
    remember();
    track('ardor_aframe_ai_used', { style: b.style, size: b.size, logo: !!b.logoId });
    $('.afi__busy-t', card).textContent = 'Opening the A-frame sign builder' + ELL;
    $('.afi__busy-s', card).textContent = '';
    statusEl.textContent = 'Opening the A-frame sign builder' + ELL;
    const ev = new CustomEvent('ardor:aframe-ai-handoff', { bubbles: true, cancelable: true, detail: { url, image: fin, preview: img, batch: b } });
    if (root.dispatchEvent(ev)) { window.location.assign(url); return; }
    done();
    S.busy = false;
    setBusyUi(false);
  }

  form.addEventListener('submit', (e) => { e.preventDefault(); generate(); });
  againBtn.addEventListener('click', () => generate());
  editBtn.addEventListener('click', () => {
    form.scrollIntoView({ behavior: 'smooth', block: 'start' });
    setTimeout(() => lineIns.headline.focus({ preventScroll: true }), 350);
  });

  /* ---------- email unlock (same as the other generators: Shopify customer form into a hidden iframe) ---------- */
  function openGate() {
    showErr('', gateErr);
    gateEmail.value = email || '';
    if (gateN) gateN.textContent = String(S.emailTries);
    if (gate.showModal) { try { gate.showModal(); } catch (e) { gate.setAttribute('open', ''); } }
    else gate.setAttribute('open', '');
    setTimeout(() => gateEmail.focus(), 60);
    track('ardor_aframe_ai_gate_shown', {});
  }
  function closeGate() { if (gate.close) gate.close(); else gate.removeAttribute('open'); }
  $('[data-afi-gate-close]').addEventListener('click', closeGate);
  gate.addEventListener('click', (e) => { if (e.target === gate) closeGate(); });
  function customerForm() {
    let f = root.querySelector('form#afi-customer');
    if (!f) {
      f = document.createElement('form');
      f.id = 'afi-customer';
      f.method = 'post';
      f.action = '/contact#afi-customer';
      f.className = 'afi__customer';
      f.innerHTML = '<input type="hidden" name="form_type" value="customer"><input type="hidden" name="utf8" value="\u2713"><input type="hidden" name="contact[tags]" value="newsletter,ai-aframe-generator,ardor-aframe-builder"><input type="hidden" name="contact[email]" data-afi-customer-email>';
      root.appendChild(f);
    }
    return f;
  }
  function subscribe(addr) {
    const f = customerForm();
    const field = f.querySelector('[name="contact[email]"]');
    if (field) field.value = addr;
    f.target = 'afi-sink';
    try { if (f.requestSubmit) f.requestSubmit(); else f.submit(); } catch (e) { try { f.submit(); } catch (e2) { /* ignore */ } }
  }
  gateForm.addEventListener('submit', async (e) => {
    e.preventDefault();
    const addr = gateEmail.value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(addr)) { showErr('Please enter a valid email.', gateErr); gateEmail.focus(); return; }
    email = addr;
    store.set('wsIdeaEmail', addr);
    S.hasEmail = true;
    subscribe(addr);
    track('ardor_aframe_ai_email', {});
    const q = await api(`/api/banner/quota?visitor=${enc(visitor)}&email=${enc(addr)}`);
    if (q.ok) {
      S.triesLeft = q.bannersLeft;
      S.fixesLeft = q.fixesLeft;
      S.finalsLeft = q.finalsLeft;
      if (q.emailBanners) S.emailTries = q.emailBanners;
    }
    setQuota();
    closeGate();
    const next = S.pending;
    S.pending = null;
    if (next && !(next.kind === 'generate' && S.triesLeft === 0)) next.run();
  });

  /* ---------- start ---------- */
  Object.keys(lineIns).forEach((k) => syncCount(k, lineIns[k]));
  syncCount('notes', notesIn);
  setSize(DEFAULT_SIZE);
  const params = new URL(window.location.href).searchParams;
  const last = sget(LAST_KEY);
  if (last && last.form && Date.now() - (last.at || 0) < 36e5 * 24) {
    const f = last.form;
    lineIns.headline.value = f.headline || '';
    lineIns.subline.value = f.subline || '';
    lineIns.details.value = f.details || '';
    notesIn.value = f.notes || '';
    Object.keys(lineIns).forEach((k) => syncCount(k, lineIns[k]));
    syncCount('notes', notesIn);
    setStyle(f.style || 'bold');
    if (SIZES[f.size]) setSize(f.size);
    if (last.logo && last.logo.id) setLogo({ blob: null, id: last.logo.id, name: last.logo.name, w: last.logo.w, h: last.logo.h, thumb: last.logo.thumbData, thumbData: last.logo.thumbData });
    if (last.batch && SIZES[last.batch.size] && last.batch.images && last.batch.images.length) { S.batch = last.batch; renderResults(); }
  }
  if (SIZES[params.get('size')]) setSize(params.get('size'));

  (async () => {
    const q = await api(`/api/banner/quota?visitor=${enc(visitor)}${email ? `&email=${enc(email)}` : ''}`, null, 20000);
    if (!q.ok) return;
    if (q.enabled === false) {
      S.off = true;
      goBtn.disabled = true;
      showErr(OFF_MSG);
    }
    S.triesLeft = q.bannersLeft;
    S.fixesLeft = q.fixesLeft;
    S.finalsLeft = q.finalsLeft;
    S.hasEmail = !!q.hasEmail;
    if (q.freeBanners) S.freeTries = q.freeBanners;
    if (q.emailBanners) S.emailTries = q.emailBanners;
    setQuota();
  })();
  if (SITEKEY) loadTurnstile();
})();
